import { GroupBox, Link } from '@infotech-soe/erp-ui-kit';
import { DSAgents } from '@infotech-soe/mia-ds-service/types';
import React, { memo, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { DSLoginFormContainerProps } from '../session/AuthFormContainer';

import { IIT_AGENT_DOWNLOAD_LINK, JAVA_DOWNLOAD_LINK } from './constants';
import { notAvailableFormMessages } from './messages';

type NotAvailableFormProps = Pick<DSLoginFormContainerProps, 'dsAgent'>;

const AgentNotAvailableForm = ({ dsAgent }: NotAvailableFormProps) => {
  const { formatMessage } = useIntl();

  const agentHref = useMemo(
    () =>
      dsAgent === DSAgents.CIPHER
        ? process.env.CIPHER_AGENT_LINK
        : IIT_AGENT_DOWNLOAD_LINK,
    [dsAgent]
  );

  return (
    <GroupBox>
      <GroupBox.Content className="column">
        {formatMessage(notAvailableFormMessages.title)}
        <Link href={agentHref} className="m-pa-lg">
          {formatMessage(notAvailableFormMessages.agentLink)}
        </Link>
        {dsAgent === DSAgents.CIPHER && (
          <Link href={JAVA_DOWNLOAD_LINK} className="m-px-lg m-pb-lg">
            {formatMessage(notAvailableFormMessages.javaLink)}
          </Link>
        )}
        {formatMessage(notAvailableFormMessages.access)}
      </GroupBox.Content>
    </GroupBox>
  );
};

export default memo(AgentNotAvailableForm);
